import {Type} from "./Type";
export class Photo {
	id: number;
	url: string;
	description: string;
	type: Type;
}


// WEBPACK FOOTER //
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/app/model/Photo.ts